import React from 'react';
import contentTypeEnum from '../../../enums/contentTypeEnum';
import GeniallyContent from './contentRenderers/GeniallyContent';
import YoutubeContent from './contentRenderers/YoutubeContent';
import ImageContent from './contentRenderers/ImageContent';
import PdfContent from './contentRenderers/PdfContent';
import classes from './ContentPromotionPopup.module.css';

const PromotionContent = ({ contentType, url, title }) => {

    const renderContent = () => {
        switch (contentType) {
            case contentTypeEnum.Genially:
                return <GeniallyContent url={url} title={title} />;
            case contentTypeEnum.Youtube:
                return <YoutubeContent url={url} title={title} />;
            case contentTypeEnum.Image:
                return <ImageContent url={url} title={title} />;
            case contentTypeEnum.Pdf:
                return <PdfContent url={url} title={title} />;
        }
    };

    return (
        <div className={classes.Content}>
            {renderContent()}
        </div>
    );
};

export default PromotionContent;
